import { getConfig } from '../config'
import { getLocaleLanguage, LanguageType } from '../utils/language'

export const loadCaptchaScript = () => {
  const url = getConfig().captchaTencent.scriptURL
  if (!url) {
    console.error('[loadCaptchaScript] app config empty')
    return
  }
  const script = document.createElement('script')
  script.setAttribute('src', url)
  script.setAttribute('src', url)
  script.defer = true
  document.body.insertBefore(script, document.body.children[0])
}

const checkCaptchaCallback = (res, callback, errorCallback) => {
  if (res.ret === 0 && res.ticket) {
    console.log('check captcha success', res)
    callback(res.ticket, res.randstr)
  } else {
    console.log('check captcha failed', res)
    errorCallback()
  }
}
// 验证码js加载错误处理
const loadCaptchaJsErrorCallback = (callback, errorCallback) => {
  const appID = getConfig().captchaTencent.appID
  // 生成票据或自行做其它处理
  const ticket = 'terror_1001_' + appID + Math.floor(new Date().getTime() / 1000)
  checkCaptchaCallback({
    ret: 0,
    randstr:
      '@' +
      Math.random()
        .toString(36)
        .substr(2),
    ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  }, callback, errorCallback)
}

export const showCaptcha = (callback, errorCallback) => {
  try {
    const appID = getConfig().captchaTencent.appID
    if (!appID) {
      console.error('[showCaptcha] app config empty')
      return
    }
    const language = getLocaleLanguage() || LanguageType.en_US
    // 生成一个验证码对象
    // eslint-disable-next-line no-undef
    const captcha = new TencentCaptcha(
      appID, // 验证码appid
      res => checkCaptchaCallback(res, callback, errorCallback), // 验证码回调函数
      {
        // 验证码options配置参数
        userLanguage: language, // 指定语言
        needFeedBack: false // 不需要帮助按钮
      }
    )
    // 显示验证码
    captcha.show()
  } catch (error) {
    console.log('show captcha error: ', error)
    loadCaptchaJsErrorCallback(callback, errorCallback)
  }
}



// WEBPACK FOOTER //
// ./src/utils/captcha.js